import { MailNotifyData } from '../../../src_server/entity/master/MailNotifyData';
export class NotifyMail {
  openMailWindow(mail: string, subject: string, body: string) {
    const sanitizeBody = decodeURI(body);
    const url = `https://mail.google.com/mail/?view=cm&fs=1&to=${mail}&su=${subject}&body=${body}`;
    window.open(url, '_blank');
  }

  openMailToAppoint(mail: string, to_name: string) {
    const message = MailNotifyData.windowTeacherInterviewAppoint(to_name);
    this.openMailWindow(mail, message.subject, message.body);
  }

  openMailToFailur(mail: string, to_name: string) {
    const message = MailNotifyData.teacherFailureMail(to_name);
    this.openMailWindow(mail, message.subject, message.body);
  }
}
